<template>
  <div class="modalContents__object12">
    <div class="container">
      <div class="row no-gutters">
        <div class="col-lg-7 col-md-8 col-10 mx-auto row no-gutters">
          <p class="col-12 text-center">お問い合わせありがとうございます。
            <br>弊社スタッフが内容を確認しましたら折り返し連絡いたします。
          </p>
          <div class="col-md-8 mx-auto">
            <span class="text-center" @click="hideModal">閉じる</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import MultiModalMixin from "../mixins/ModalMixin";
export default {
  name: "ContactThanks",
  mixins: [MultiModalMixin]
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/vue/component/modal/contact_thanks.vue